/* Fashiontiger PDP enhancements / compact v8. FoxTheme remains in charge of variants and cart. */
(() => {
  if (window.__ftPdpEnhancedV8) return;
  window.__ftPdpEnhancedV8 = true;

  if (!customElements.get('ft-media-gallery')) {
    customElements.define('ft-media-gallery', class FtMediaGallery extends HTMLElement {
      connectedCallback() { this.init(); }

      init() {
        if (this.dataset.ftGalleryReady === 'true') return;
        this.dataset.ftGalleryReady = 'true';
        this.thumbs = Array.from(this.querySelectorAll('[data-ft-gallery-thumb]'));
        this.panels = Array.from(this.querySelectorAll('[data-ft-gallery-panel]'));
        this.rail = this.querySelector('[data-ft-gallery-thumbs]');
        this.wideGalleryQuery = window.matchMedia('(min-width: 768px) and (max-width: 1023.98px), (min-width: 1500px)');
        this.onGalleryModeChange = () => {
          const current = this.thumbs.find((thumb) => thumb.getAttribute('aria-current') === 'true');
          const currentId = current?.dataset.mediaId || this.panels.find((panel) => panel.classList.contains('is-active'))?.dataset.ftGalleryPanel || this.panels[0]?.dataset.ftGalleryPanel;
          if (currentId) this.activateMedia(currentId, false);
        };
        /* Track the individual breakpoints: the combined wide-gallery media
           query can remain 'true' when jumping from desktop to tablet. */
        this.layoutBreakpoints = [768, 1024, 1500].map((width) => window.matchMedia(`(min-width: ${width}px)`));
        this.layoutBreakpoints.forEach((query) => query.addEventListener?.('change', this.onGalleryModeChange));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.activateMedia(thumb.dataset.mediaId));
        });

        const current = this.thumbs.find((thumb) => thumb.getAttribute('aria-current') === 'true');
        const initialId = current?.dataset.mediaId || this.panels[0]?.dataset.ftGalleryPanel;
        if (initialId) this.activateMedia(initialId, false);

        // Sleek loads the PhotoSwipe library separately, after this gallery script.
        // The original library does not bind itself to a custom <ft-media-gallery>.
        this.initPhotoSwipe();
      }

      initPhotoSwipe() {
        if (this.photoSwipeLightbox || !this.querySelector('.js-photoswipe--zoom')) return;

        const attach = () => {
          const { PhotoSwipe, PhotoSwipeLightbox } = window.FoxTheme || {};
          if (!PhotoSwipe || !PhotoSwipeLightbox || this.photoSwipeLightbox) return false;

          // Use Sleek's actual PhotoSwipe 5 classes and native viewer.
          // Every gallery image is a slide, including images hidden in a carousel.
          const lightbox = new PhotoSwipeLightbox({
            gallery: this,
            children: '.product__media-item[data-media-type="image"]',
            pswpModule: PhotoSwipe,
            // Sleek uses its own prev / close / next toolbar, rather than
            // PhotoSwipe's generic arrows, zoom icon and counter.
            arrowPrev: false,
            arrowNext: false,
            close: false,
            zoom: false,
            counter: false,
            preloader: false
          });

          // Scope the product-photo background to this gallery's PhotoSwipe viewer.
          // The original 3:4 image dimensions and zoom behaviour stay unchanged.
          lightbox.on('afterInit', () => {
            lightbox.pswp?.element?.classList.add('ft-pdp-photo-lightbox');
          });

          // Match the original Sleek PhotoSwipe toolbar and its theme CSS.
          // This registers buttons in the existing PhotoSwipe viewer; it does
          // not create a separate modal or inject another set of controls.
          lightbox.on('uiRegister', () => {
            const pswp = lightbox.pswp;
            if (!pswp) return;

            const controls = [
              {
                name: 'sleekPrev',
                className: 'pswp__button--prev',
                ariaLabel: 'Previous slide',
                order: 1,
                html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100" aria-hidden="true"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
                onClick: 'prev'
              },
              {
                name: 'sleekCloseZoom',
                className: 'pswp__button--close-zoom',
                ariaLabel: 'Close zoom image',
                order: 2,
                html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
                onClick: 'close'
              },
              {
                name: 'sleekNext',
                className: 'pswp__button--next',
                ariaLabel: 'Next slide',
                order: 3,
                html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100" aria-hidden="true"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
                onClick: 'next'
              }
            ];

            controls.forEach((control) => {
              pswp.ui.registerElement({
                ...control,
                isButton: true,
                appendTo: 'bar'
              });
            });
          });

          // product-thumbnail.liquid stores these attributes on the media DIV;
          // the PhotoSwipe default parser only reads them from an A element.
          lightbox.addFilter('domItemData', (data, element) => {
            const { src, pswpWidth, pswpHeight, alt } = element.dataset;
            const image = element.querySelector('img');
            const width = Number(pswpWidth);
            const height = Number(pswpHeight);
            if (src) data.src = src;
            if (width > 0 && height > 0) {
              data.width = data.w = width;
              data.height = data.h = height;
            }
            data.msrc = image?.currentSrc || image?.src || '';
            data.alt = alt || image?.alt || '';
            return data;
          });

          lightbox.init();
          this.photoSwipeLightbox = lightbox;
          return true;
        };

        if (attach()) return;
        // The deferred photoswipe.js may not have executed yet: bind once
        // to that existing script instead of loading a second copy.
        const script = Array.from(document.scripts).find((item) =>
          /(?:^|\/)photoswipe\.js(?:\?|$)/i.test(item.src || '')
        );
        if (script) script.addEventListener('load', attach, { once: true });
        window.addEventListener('load', attach, { once: true });
      }

      setActiveMedia(variant) {
        const mediaId = variant?.featured_media?.id;
        if (mediaId) this.activateMedia(String(mediaId));
      }

      activateMedia(mediaId, shouldFocus = false) {
        const id = String(mediaId);
        let activePanel = null;
        let activeThumb = null;

        const wideGallery = this.wideGalleryQuery?.matches === true;
        const showAll = window.matchMedia('(min-width: 1500px)').matches ||
          (window.matchMedia('(min-width: 1024px)').matches && this.classList.contains('ft-pdp-media-gallery--three'));
        const activeIndex = this.panels.findIndex((panel) => panel.dataset.ftGalleryPanel === id);
        const companionIndex = wideGallery && this.panels.length > 1
          ? (activeIndex + 1) % this.panels.length
          : -1;

        this.panels.forEach((panel, index) => {
          const active = panel.dataset.ftGalleryPanel === id;
          const companion = index === companionIndex && !active;
          panel.hidden = !showAll && !(active || companion);
          panel.classList.toggle('is-active', active);
          panel.classList.toggle('is-wide-companion', companion);
          if (active) activePanel = panel;
        });

        this.thumbs.forEach((thumb) => {
          const active = thumb.dataset.mediaId === id;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) activeThumb = thumb;
        });

        this.querySelectorAll('video').forEach((video) => {
          if (!activePanel || !activePanel.contains(video)) video.pause?.();
        });
        activePanel?.querySelector('video')?.play?.().catch(() => {});


        if (activeThumb && this.rail) {
          const horizontal = getComputedStyle(this.rail).flexDirection === 'row';
          if (horizontal) {
            const left = activeThumb.offsetLeft;
            const right = left + activeThumb.offsetWidth;
            if (left < this.rail.scrollLeft) this.rail.scrollLeft = left;
            if (right > this.rail.scrollLeft + this.rail.clientWidth) {
              this.rail.scrollLeft = right - this.rail.clientWidth;
            }
          } else {
            const top = activeThumb.offsetTop;
            const bottom = top + activeThumb.offsetHeight;
            if (top < this.rail.scrollTop) this.rail.scrollTop = top;
            if (bottom > this.rail.scrollTop + this.rail.clientHeight) {
              this.rail.scrollTop = bottom - this.rail.clientHeight;
            }
          }
          if (shouldFocus) activeThumb.focus({ preventScroll: true });
        }
      }
    });
  }

  const FT_AMSTERDAM_TZ = 'Europe/Amsterdam';
  const FT_WEEKDAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
  const FT_WEEKDAY_NAMES_NL = { 1: 'maandag', 2: 'dinsdag', 3: 'woensdag', 4: 'donderdag', 5: 'vrijdag', 6: 'zaterdag', 7: 'zondag' };
  const ftPad = (n) => String(n).padStart(2, '0');

  function ftAmsterdamParts(date = new Date()) {
    const formatted = new Intl.DateTimeFormat('en-GB', {
      timeZone: FT_AMSTERDAM_TZ,
      year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(date);
    const get = (type) => formatted.find((part) => part.type === type)?.value;
    return {
      year: Number(get('year')), month: Number(get('month')), day: Number(get('day')),
      weekday: get('weekday'), hour: Number(get('hour')), minute: Number(get('minute')), second: Number(get('second'))
    };
  }

  function ftTimeZoneOffsetMs(date, timeZone) {
    const formatted = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(date);
    const map = {};
    formatted.forEach((part) => { map[part.type] = part.value; });
    const asUTC = Date.UTC(
      Number(map.year), Number(map.month) - 1, Number(map.day),
      Number(map.hour), Number(map.minute), Number(map.second)
    );
    return asUTC - date.getTime();
  }

  function ftAmsterdamTimestamp(year, month, day, hour, minute, second = 0) {
    const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    let offset = ftTimeZoneOffsetMs(utcGuess, FT_AMSTERDAM_TZ);
    let result = new Date(utcGuess.getTime() - offset);
    const correctedOffset = ftTimeZoneOffsetMs(result, FT_AMSTERDAM_TZ);
    if (correctedOffset !== offset) result = new Date(utcGuess.getTime() - correctedOffset);
    return result.getTime();
  }

  function ftExtractPreorderDate(value) {
    const source = String(value || '').replace(/\s+/g, ' ').trim();
    if (!source) return '';
    const dutchMonths = 'januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december';
    const englishMonths = 'january|february|march|april|may|june|july|august|september|october|november|december';
    const patterns = [
      new RegExp(`\\b\\d{1,2}\\s+(?:${dutchMonths})(?:\\s+\\d{4})?\\b`, 'i'),
      new RegExp(`\\b(?:${dutchMonths})\\s+\\d{1,2}(?:,?\\s+\\d{4})?\\b`, 'i'),
      new RegExp(`\\b\\d{1,2}\\s+(?:${englishMonths})(?:\\s+\\d{4})?\\b`, 'i'),
      new RegExp(`\\b(?:${englishMonths})\\s+\\d{1,2}(?:,?\\s+\\d{4})?\\b`, 'i'),
      /\b\d{4}-\d{1,2}-\d{1,2}\b/,
      /\b\d{1,2}[./-]\d{1,2}[./-]\d{2,4}\b/,
      /\b\d{1,2}[./-]\d{1,2}\b/
    ];
    for (const pattern of patterns) {
      const match = source.match(pattern);
      if (match) return match[0].trim();
    }
    return '';
  }

  function ftCartDrawer() {
    return document.querySelector('#CartDrawer');
  }

  function ftShippingDays(el, drawer) {
    if (drawer && ['ftMon','ftTue','ftWed','ftThu','ftFri','ftSat','ftSun'].some((key) => drawer.dataset[key] != null)) {
      return {
        1: drawer.dataset.ftMon === 'true', 2: drawer.dataset.ftTue === 'true', 3: drawer.dataset.ftWed === 'true',
        4: drawer.dataset.ftThu === 'true', 5: drawer.dataset.ftFri === 'true', 6: drawer.dataset.ftSat === 'true',
        7: drawer.dataset.ftSun === 'true'
      };
    }
    const enabled = new Set((el.dataset.shippingDays || '1,2,3,4,5').split(',').map((x) => Number(x.trim())).filter(Boolean));
    return { 1: enabled.has(1), 2: enabled.has(2), 3: enabled.has(3), 4: enabled.has(4), 5: enabled.has(5), 6: enabled.has(6), 7: enabled.has(7) };
  }

  function ftDeliveryStatus(el) {
    const drawer = el.dataset.syncCart === 'true' ? ftCartDrawer() : null;
    const now = new Date();
    const p = ftAmsterdamParts(now);
    const weekday = FT_WEEKDAYS[p.weekday] || 1;
    const days = ftShippingDays(el, drawer);
    const cutoffHour = Number(drawer?.dataset.ftCutoffHour ?? el.dataset.cutoffHour ?? 23);
    const cutoffMinute = Number(drawer?.dataset.ftCutoffMinute ?? el.dataset.cutoffMinute ?? 0);
    const cutoffTs = ftAmsterdamTimestamp(p.year, p.month, p.day, cutoffHour, cutoffMinute, 0);
    const shipsToday = Boolean(days[weekday] && now.getTime() < cutoffTs);
    return { drawer, now, weekday, days, cutoffTs, shipsToday, isWeekend: weekday === 6 || weekday === 7 };
  }

  function ftNextShippingLabel(weekday, days) {
    for (let offset = 1; offset <= 7; offset += 1) {
      const day = ((weekday - 1 + offset) % 7) + 1;
      if (!days[day]) continue;
      return offset === 1 ? 'morgen' : FT_WEEKDAY_NAMES_NL[day];
    }
    return '';
  }

  function ftSetCountdownTemplate(target, template, countdown) {
    const source = String(template || '').trim();
    target.replaceChildren();
    const marker = '{countdown}';
    const index = source.indexOf(marker);
    const strong = document.createElement('strong');
    strong.className = 'ft-delivery-countdown';
    strong.textContent = countdown;

    if (index >= 0) {
      const before = source.slice(0, index);
      const after = source.slice(index + marker.length);
      if (before) target.append(document.createTextNode(before));
      target.append(strong);
      if (after) target.append(document.createTextNode(after));
      return;
    }

    if (source) target.append(document.createTextNode(`${source} `));
    target.append(strong);
  }

  function ftReplaceDeliveryTokens(template, replacements = {}) {
    let output = String(template || '');
    Object.entries(replacements).forEach(([key, value]) => {
      output = output.split(`{${key}}`).join(String(value ?? ''));
    });
    return output.replace(/\s+/g, ' ').trim();
  }

  /* Mobile only: a two-line status replaces the long single-line sentence.
     The desktop template and its full countdown stay unchanged. */
  function ftMobileDeliverySummary(el, detail, message, countdown = '') {
    let summary = el.querySelector('[data-ft-delivery-mobile-summary]');
    if (!summary) {
      summary = document.createElement('span');
      summary.className = 'ft-pdp-delivery__mobile-summary';
      summary.dataset.ftDeliveryMobileSummary = '';

      const first = document.createElement('span');
      first.className = 'ft-pdp-delivery__mobile-line';
      if (el.querySelector(':scope > .ft-pdp-delivery__dot')) {
        const dot = document.createElement('span');
        dot.className = 'ft-pdp-delivery__dot';
        dot.setAttribute('aria-hidden', 'true');
        first.append(dot);
      }
      const stock = document.createElement('strong');
      stock.textContent = 'Op voorraad';
      first.append(stock);
      const separator = document.createElement('span');
      separator.className = 'ft-pdp-delivery__mobile-separator';
      separator.textContent = '·';
      first.append(separator);
      const detailNode = document.createElement('span');
      detailNode.dataset.ftDeliveryMobileDetail = '';
      first.append(detailNode);

      const second = document.createElement('span');
      second.className = 'ft-pdp-delivery__mobile-line ft-pdp-delivery__mobile-line--second';
      const text = document.createElement('span');
      text.dataset.ftDeliveryMobileText = '';
      second.append(text);
      const timer = document.createElement('strong');
      timer.dataset.ftDeliveryMobileTimer = '';
      second.append(timer);

      summary.append(first, second);
      el.append(summary);
    }

    const separator = summary.querySelector('.ft-pdp-delivery__mobile-separator');
    separator.hidden = !detail;
    summary.querySelector('[data-ft-delivery-mobile-detail]').textContent = detail;
    const second = summary.querySelector('.ft-pdp-delivery__mobile-line--second');
    second.hidden = !message;
    summary.querySelector('[data-ft-delivery-mobile-text]').textContent = message;
    const timer = summary.querySelector('[data-ft-delivery-mobile-timer]');
    timer.textContent = countdown;
    timer.hidden = !countdown;
  }

  function delivery(scope = document) {
    const deliveryItems = scope.matches?.('.ft-pdp')
      ? scope.querySelectorAll('[data-ft-delivery]')
      : scope.querySelectorAll?.('.ft-pdp [data-ft-delivery]');

    deliveryItems?.forEach((el) => {
      const target = el.querySelector('[data-ft-delivery-message]');
      const stock = el.querySelector('[data-ft-delivery-stock]');
      if (!target || !stock) return;

      const preorder = el.dataset.preorder === 'true';
      const available = stock.dataset.available !== 'false';
      el.classList.toggle('is-preorder', preorder);
      el.classList.toggle('is-soldout', !preorder && !available);
      el.classList.toggle('is-in-stock', !preorder && available);
      el.classList.toggle('has-mobile-delivery', !preorder && available);

      if (preorder) {
        stock.textContent = 'Pre-order';
        const info = (el.dataset.preorderText || '').trim();
        const preorderDate = ftExtractPreorderDate(info);
        if (preorderDate) {
          target.textContent = ftReplaceDeliveryTokens(
            el.dataset.preorderTemplate || 'Verwachte verzending {date}',
            { date: preorderDate }
          );
        } else {
          target.textContent = info || el.dataset.preorderFallback || 'Bekijk de verwachte leverdatum bij het product';
        }
        return;
      }

      if (!available) {
        stock.textContent = 'Uitverkocht';
        target.textContent = el.dataset.soldoutText || 'Meld je aan voor een voorraadmelding';
        return;
      }

      stock.textContent = 'Op voorraad';
      const status = ftDeliveryStatus(el);
      // Never infer NL if the Shopify market country is unavailable.
      const country = String(el.dataset.country || '').trim().toUpperCase();

      if (status.shipsToday) {
        const remaining = Math.max(0, status.cutoffTs - status.now.getTime());
        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const countdown = `${hours}h ${ftPad(minutes)}m ${ftPad(seconds)}s`;
        const saturdayDelivery = status.drawer
          ? status.drawer.dataset.ftSaturdayDelivery === 'true'
          : el.dataset.saturdayDelivery === 'true';

        let template = country === 'NL' ? el.dataset.beforeNl : el.dataset.beforeInt;
        if (country === 'NL' && status.weekday === 5 && !saturdayDelivery) {
          template = el.dataset.beforeFriday || template;
        }
        ftSetCountdownTemplate(target, template || 'Vandaag verzonden · Bestel binnen {countdown}', countdown);
        // Only promise next-day delivery in NL on normal weekday shipping days,
        // and on Friday if Saturday delivery is enabled. Other days keep the
        // original 'Vandaag verzonden' claim instead of promising Sunday delivery.
        const deliversTomorrow = country === 'NL' && (
          (status.weekday >= 1 && status.weekday <= 4) ||
          (status.weekday === 5 && saturdayDelivery)
        );
        const mobileDetail = deliversTomorrow ? 'Morgen bezorgd' : 'Vandaag verzonden';
        // Mobile shows seconds too; retain the same Amsterdam cutoff calculation.
        const mobileTimer = hours > 0
          ? `${hours}u ${ftPad(minutes)}m ${ftPad(seconds)}s`
          : minutes > 0
            ? `${minutes}m ${ftPad(seconds)}s`
            : `${Math.max(1, seconds)}s`;
        ftMobileDeliverySummary(el, mobileDetail, 'Bestel binnen ', mobileTimer);
        return;
      }

      const nextDay = ftNextShippingLabel(status.weekday, status.days) || 'volgende verzenddag';
      const template = status.isWeekend ? el.dataset.weekend : el.dataset.after;
      target.textContent = ftReplaceDeliveryTokens(
        template || 'Vandaag besteld · {day} verzonden',
        { day: nextDay }
      );
      ftMobileDeliverySummary(el, '', target.textContent);
    });
  }

  function updateDeliveryVariant(page, variant) {
    const stock = page.querySelector('[data-ft-delivery-stock]');
    if (!stock || !variant) return;
    stock.dataset.available = variant.available ? 'true' : 'false';
    delivery(page);
  }


  function syncStoreAvailability(page) {
    const purchaseBlock = page.querySelector('.product__block--buy_buttons');
    if (!purchaseBlock) return;
    const linkBlock = page.querySelector('.stofind-find-in-store-button');
    if (!linkBlock) return;
    let slot = page.querySelector('.ft-pdp-store-availability-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'product__block ft-pdp-store-availability-slot';
      purchaseBlock.insertAdjacentElement('afterend', slot);
    }
    if (linkBlock.parentElement !== slot) slot.appendChild(linkBlock);
  }

  function syncPurchaseState(page) {
    if (!page) return;
    syncStoreAvailability(page);
    const deliveryEl = page.querySelector('[data-ft-delivery]');
    const stock = page.querySelector('[data-ft-delivery-stock]');
    const buyBlock = page.querySelector('.product__block--buy_buttons');
    const backBlock = page.querySelector('[data-ft-back-in-stock-block]');
    const cartSlot = buyBlock?.querySelector('.ft-pdp-purchase-actions__cart');
    const purchaseRow = buyBlock?.querySelector('.ft-pdp-purchase-actions');
    if (!stock || !cartSlot || !purchaseRow) return;

    const preorder = deliveryEl?.dataset.preorder === 'true';
    const soldOut = !preorder && stock.dataset.available === 'false';

    if (backBlock) {
      // Keep AMP inside the original cart column so wishlist stays present
      // in exactly the same position for available and sold-out products.
      if (backBlock.parentElement !== cartSlot) cartSlot.appendChild(backBlock);
      backBlock.classList.toggle('is-active', soldOut);
    }
    purchaseRow.classList.toggle('is-soldout', soldOut && Boolean(backBlock));
  }

  function installPurchaseStateWatcher(page) {
    const blocks = page.querySelector('.product__blocks');
    if (!blocks || blocks.dataset.ftPurchaseWatcher === 'true') return;
    blocks.dataset.ftPurchaseWatcher = 'true';
    const observer = new MutationObserver(() => syncPurchaseState(page));
    observer.observe(blocks, { childList: true, subtree: true });
  }

  function syncKlarna(page) {
    const from = page.querySelector('[data-ft-installment-source]');
    if (!from) return;
    page.querySelectorAll('[data-ft-installment]').forEach((el) => {
      if (el.textContent !== from.textContent) el.textContent = from.textContent;
    });
  }

  function installPriceObserver(page) {
    if (page.dataset.ftPriceObserved) return;
    const price = page.querySelector('[id^="price-"]');
    if (!price) return;
    page.dataset.ftPriceObserved = 'true';
    const watcher = new MutationObserver(() => syncKlarna(page));
    watcher.observe(price, { childList: true, subtree: true, characterData: true });
    syncKlarna(page);
  }

  function removeLegacySwatchKing(page) {
    const picker = page.querySelector('.product__block--variant_picker');
    if (!picker) return;
    picker.querySelectorAll('variant-swatch-king, [data-swatch-king], .swatch-king, [class*=\"swatch-king\"]').forEach((node) => node.remove());
    if (picker.dataset.ftSwatchKingGuard) return;
    picker.dataset.ftSwatchKingGuard = 'true';
    const guard = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('variant-swatch-king, [data-swatch-king], .swatch-king, [class*=\"swatch-king\"]')) node.remove();
        node.querySelectorAll?.('variant-swatch-king, [data-swatch-king], .swatch-king, [class*=\"swatch-king\"]').forEach((child) => child.remove());
      }));
    });
    guard.observe(picker, { childList: true, subtree: true });
  }

  async function initializeLooks(page) {
    for (const section of page.querySelectorAll('[data-ft-look-section][data-ft-needs-recommendations="true"]')) {
      if (section.dataset.ftRequested) continue;
      section.dataset.ftRequested = 'true';
      try {
        const response = await fetch(section.dataset.ftLookUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Shop the Look request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = doc.querySelector('[data-ft-look-products]');
        const dest = section.querySelector('[data-ft-look-products]');
        if (cards && dest && cards.querySelector('.ft-pdp-look__card')) {
          dest.innerHTML = cards.innerHTML;
          section.hidden = false;
          section.dispatchEvent(new CustomEvent('recommendations:loaded', { bubbles: true }));
        }
      } catch (error) {
        console.warn('FT product recommendations unavailable:', error);
      }
    }
  }

  /* Shop the Look / TikTok pagination. Items remain their original DOM nodes:
     product-card links, video controls and recommendation hydration still work. */
  function paginateExtraSection(section, reset = false) {
    const rail = section.querySelector('.ft-pdp-look__products, .ft-pdp-tiktoks__rail');
    if (!rail) return;
    const selector = rail.matches('.ft-pdp-look__products') ? '.ft-pdp-look__card' : '.ft-pdp-tiktoks__item';
    const items = Array.from(rail.children).filter((node) => node.matches(selector));
    const perPage = 3;
    const pages = Math.max(1, Math.ceil(items.length / perPage));
    const lastIndex = pages - 1;
    const previous = Number(section.dataset.ftExtraPage || 0);
    const active = reset ? 0 : Math.max(0, Math.min(lastIndex, Number.isFinite(previous) ? previous : 0));
    section.dataset.ftExtraPage = String(active);

    items.forEach((item, index) => {
      const visible = index >= active * perPage && index < (active + 1) * perPage;
      item.hidden = !visible;
      item.setAttribute('aria-hidden', String(!visible));
      if (!visible) item.querySelectorAll('video').forEach((video) => video.pause?.());
    });

    let controls = section.querySelector('.ft-pdp-extras__pagination');
    if (pages <= 1) {
      controls?.remove();
      return;
    }
    if (!controls) {
      controls = document.createElement('nav');
      controls.className = 'ft-pdp-extras__pagination';
      controls.setAttribute('aria-label', rail.matches('.ft-pdp-look__products') ? 'Shop the Look pagina’s' : 'TikTok pagina’s');
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'ft-pdp-extras__page-button';
      back.setAttribute('aria-label', 'Vorige pagina');
      back.textContent = '‹';
      const counter = document.createElement('span');
      counter.className = 'ft-pdp-extras__page-label';
      counter.setAttribute('aria-live', 'polite');
      const forward = document.createElement('button');
      forward.type = 'button';
      forward.className = 'ft-pdp-extras__page-button';
      forward.setAttribute('aria-label', 'Volgende pagina');
      forward.textContent = '›';
      back.addEventListener('click', () => {
        section.dataset.ftExtraPage = String(Number(section.dataset.ftExtraPage || 0) - 1);
        paginateExtraSection(section);
      });
      forward.addEventListener('click', () => {
        section.dataset.ftExtraPage = String(Number(section.dataset.ftExtraPage || 0) + 1);
        paginateExtraSection(section);
      });
      controls.append(back, counter, forward);
      section.appendChild(controls);
    }
    const [back, counter, forward] = controls.children;
    back.disabled = active === 0;
    counter.textContent = `${active + 1} / ${pages}`;
    forward.disabled = active >= lastIndex;
  }

  function initializeExtras(page) {
    page.querySelectorAll('.ft-pdp-extras').forEach((section) => {
      if (section.dataset.ftExtrasReady !== 'true') {
        section.dataset.ftExtrasReady = 'true';
        section.addEventListener('recommendations:loaded', () => paginateExtraSection(section, true));
      }
      paginateExtraSection(section);
    });
  }
  /* Fashiontiger heart: delegate to native Swish product button whenever it
     is mounted. The browser API is only a fallback. Product cards use this
     same app's own controls, so we prefer its authenticated click handling. */
  let ftSwishPromise;
  function getSwish() {
    if (!ftSwishPromise) {
      ftSwishPromise = import('/apps/wishlist/assets/swish.js')
        .then(({ swishApp }) => swishApp({ proxy: { baseUrl: '/apps/wishlist' } }))
        .catch((error) => { ftSwishPromise = null; throw error; });
    }
    return ftSwishPromise;
  }
  function wishlistProductId(button) { return Number(button.dataset.ftProductId || 0); }
  function wishlistVariantId(button) { return Number(button.dataset.ftVariantId || 0); }
  function wishlistNativeControl(page) {
    const engine = page.querySelector('[data-ft-wishlist-engine]');
    if (!engine) return null;
    const nodes = engine.querySelectorAll('button, wishlist-button-product, xb-wishlist-button-product, [role="button"], .wk-button, [class*="wishlist-button"]');
    for (const node of nodes) {
      if (node.closest('[data-ft-pdp-wishlist-button]')) continue;
      if (node.matches('button,[role="button"]')) return node;
      const nested = node.shadowRoot?.querySelector('button,[role="button"]') || node.querySelector('button,[role="button"]');
      if (nested) return nested;
      if (node.matches('wishlist-button-product, xb-wishlist-button-product, .wk-button')) return node;
    }
    return null;
  }
  function waitForNativeWishlist(page, maxMs = 2400) {
    const existing = wishlistNativeControl(page);
    if (existing) return Promise.resolve(existing);
    const root = page.querySelector('[data-ft-wishlist-engine]');
    if (!root) return Promise.resolve(null);
    return new Promise((resolve) => {
      let done = false;
      const finish = (value) => {
        if (done) return;
        done = true;
        observer.disconnect();
        window.clearTimeout(timeout);
        resolve(value);
      };
      const observer = new MutationObserver(() => {
        const found = wishlistNativeControl(page);
        if (found) finish(found);
      });
      observer.observe(root, { childList: true, subtree: true, attributes: true });
      const timeout = window.setTimeout(() => finish(wishlistNativeControl(page)), maxMs);
    });
  }
  function setWishlistState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Verwijder uit wishlist' : 'Toevoegen aan wishlist');
  }
  function nativeWishlistActive(native) {
    const element = native.closest('.wk-button, [class*="wishlist-button"]') || native;
    const cls = `${element.className || ''} ${native.className || ''}`.toLowerCase();
    if (native.getAttribute('aria-pressed') === 'true' || element.getAttribute('aria-pressed') === 'true') return true;
    if (/\b(is-)?(active|wishlisted|added|selected)\b/.test(cls)) return true;
    return null; // unknown: keep optimistic feedback, let Swish handle the click
  }
  async function readWishlistState(button) {
    const swish = await getSwish();
    const api = swish?.api?.items;
    if (!api?.list) throw new Error('Swish items API is niet beschikbaar');
    const result = await api.list({query:`product:${wishlistProductId(button)}`,limit:50});
    if (result?.error) throw result.error;
    const payload = result?.data;
    const items = Array.isArray(payload) ? payload : Array.isArray(payload?.data) ? payload.data
      : Array.isArray(payload?.items) ? payload.items : [];
    const item = items.find(entry => Number(entry.productId || entry.product?.id) === wishlistProductId(button));
    return {swish,api,item};
  }
  async function syncWishlistButton(page) {
    const button = page.querySelector('[data-ft-pdp-wishlist-button]');
    if (!button || button.dataset.ftWishlistBusy === 'true') return;
    const native = wishlistNativeControl(page);
    if (native) {
      const active = nativeWishlistActive(native);
      if (active !== null) setWishlistState(button, active);
      return;
    }
    try {
      const {item} = await readWishlistState(button);
      if (button.dataset.ftWishlistBusy !== 'true') setWishlistState(button, Boolean(item));
    } catch (error) {
      // The native button can still become available after the app finishes loading.
      console.debug('Swish wishlist status nog niet beschikbaar:', error);
    }
  }
  function installWishlistButton(page) {
    const button = page.querySelector('[data-ft-pdp-wishlist-button]');
    if (!button || button.dataset.ftWishlistReady === 'true') return;
    button.dataset.ftWishlistReady = 'true';
    button.addEventListener('click', async () => {
      if (button.dataset.ftWishlistBusy === 'true') return;
      button.dataset.ftWishlistBusy = 'true';
      button.setAttribute('aria-busy','true');
      const previous = button.getAttribute('aria-pressed') === 'true';
      const status = button.querySelector('[data-ft-pdp-wishlist-status]');
      if (status) status.textContent = 'Wishlist bijwerken…';
      setWishlistState(button,!previous);
      button.removeAttribute('title');
      try {
        const native = await waitForNativeWishlist(page);
        if (native) {
          native.click();
          if (status) status.textContent = 'Wishlist-actie wordt verwerkt';
          window.setTimeout(() => syncWishlistButton(page), 600);
        } else {
          // Native app was not mounted: use documented Swish browser API.
          const productId = wishlistProductId(button);
          const variantId = wishlistVariantId(button);
          const swish = await getSwish();
          const api = swish?.api?.items;
          if (!api?.create || !api?.list || !api?.deleteById) throw new Error('Swish API ontbreekt');
          if (!previous) {
            const result = await api.create({productId, ...(variantId ? {variantId} : {}),quantity:1});
            if (result?.error) throw result.error;
          } else {
            const {item} = await readWishlistState(button);
            if (item) {
              const result = await api.deleteById(item.id);
              if (result?.error) throw result.error;
            }
          }
          if (status) status.textContent = previous ? 'Verwijderd uit wishlist' : 'Toegevoegd aan wishlist';
        }
        document.dispatchEvent(new CustomEvent('ft:wishlist:updated', {detail:{productId:wishlistProductId(button),active:!previous}}));
      } catch (error) {
        setWishlistState(button,previous);
        button.title='Wishlist kan niet worden bijgewerkt';
        if (status) status.textContent = 'Wishlist niet bijgewerkt. Controleer de Swish-appkoppeling.';
        console.error('Fashiontiger Swish wishlist fout:', error);
        // Signed-out customers can use Swish's native sign-in dialog where available.
        const code = String(error?.status || error?.code || '');
        if (code === '401' || code === '403') {
          try { const swish=await getSwish(); await swish.ui?.showSignIn?.({returnTo:window.location.pathname}); }
          catch (_) { /* user receives the visible failure status above */ }
        }
      } finally {
        button.dataset.ftWishlistBusy='false';
        button.removeAttribute('aria-busy');
      }
    });
    const nativeRoot = page.querySelector('[data-ft-wishlist-engine]');
    if (nativeRoot) {
      const observer = new MutationObserver(() => {
        if (button.dataset.ftWishlistBusy !== 'true') {
          const native = wishlistNativeControl(page);
          if (native) {
            const active = nativeWishlistActive(native);
            if (active !== null) setWishlistState(button,active);
          }
        }
      });
      observer.observe(nativeRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['class','aria-pressed','data-state']});
    }
    syncWishlistButton(page);
  }

  /* Keep the bottoms of the desktop gallery and information column aligned.
     On desktop the shorter column becomes sticky within the shared product grid.
     A negative sticky top is needed when the shorter column is taller than the
     viewport, otherwise its last items could never be seen while scrolling. */
  function installAdaptiveColumnSticky(page) {
    const product = page.querySelector('.product');
    const media = product?.querySelector(':scope > .product__media-wrapper');
    const info = product?.querySelector(':scope > .product__info-wrapper');
    const threePhotoGallery = media?.querySelector('.ft-pdp-media-gallery--three');
    if (!media || !info || product.dataset.ftAdaptiveStickyReady === 'true') return;
    product.dataset.ftAdaptiveStickyReady = 'true';

    const desktop = window.matchMedia('(min-width: 1024px)');
    // Record the gallery's NATURAL top once so scroll/sticky movement cannot
    // change its initial viewport-fit height.
    let threeGalleryInset = null;
    let queued = 0;
    const update = () => {
      queued = 0;
      if (!product.isConnected) return;
      if (!desktop.matches) {
        threePhotoGallery?.style.removeProperty('--ft-pdp-three-height');
        product.removeAttribute('data-ft-sticky-column');
        product.style.removeProperty('--ft-pdp-adaptive-sticky-top');
        return;
      }

      if (threePhotoGallery) {
        // The initial gallery sits below the floating header. Use the natural
        // document position of the product row, NOT the sticky media bounding box.
        // Keep 20px visible under the gallery at first page load.
        if (threeGalleryInset === null) {
          const galleryTop = threePhotoGallery.getBoundingClientRect().top;
          const productTop = product.getBoundingClientRect().top;
          threeGalleryInset = Math.max(0, galleryTop - productTop);
        }
        const documentTop = product.getBoundingClientRect().top + window.scrollY + threeGalleryInset;
        const bottomGutter = 20;
        const availableHeight = Math.max(200, Math.round(window.innerHeight - documentTop - bottomGutter));
        const previousHeight = parseFloat(threePhotoGallery.style.getPropertyValue('--ft-pdp-three-height'));
        if (!Number.isFinite(previousHeight) || Math.abs(previousHeight - availableHeight) > 1) {
          threePhotoGallery.style.setProperty('--ft-pdp-three-height', `${availableHeight}px`);
        }
      }

      /* offsetHeight measures the actual laid-out column, irrespective of its
         scroll position (unlike top/bottom from getBoundingClientRect). */
      const mediaHeight = media.offsetHeight;
      const infoHeight = info.offsetHeight;
      const gap = 2;
      let column = '';
      let shorterHeight = 0;
      if (mediaHeight + gap < infoHeight) {
        column = 'media';
        shorterHeight = mediaHeight;
      } else if (infoHeight + gap < mediaHeight) {
        column = 'info';
        shorterHeight = infoHeight;
      }

      if (!column) {
        product.removeAttribute('data-ft-sticky-column');
        product.style.removeProperty('--ft-pdp-adaptive-sticky-top');
        return;
      }

      const headerValue = parseFloat(getComputedStyle(page).getPropertyValue('--header-height'));
      const headerOffset = (Number.isFinite(headerValue) ? headerValue : 72) + 12;
      const visibleBottomOffset = window.innerHeight - shorterHeight - 16;
      // A three-photo gallery must stick just BELOW the actual floating header,
      // not at (viewport height - photo height); the latter creates a large
      // empty strip above the photos once the header becomes sticky.
      // Using its real on-screen bottom also follows the header's scroll animation.
      const floatingHeader = threePhotoGallery
        ? document.querySelector('.header-section .header, .header-sticky .header')
        : null;
      const floatingHeaderBottom = floatingHeader?.getBoundingClientRect().bottom;
      const threePhotoStickyTop = Number.isFinite(floatingHeaderBottom)
        ? Math.max(0, floatingHeaderBottom + 12)
        : headerOffset;
      const top = threePhotoGallery && column === 'media'
        ? threePhotoStickyTop
        : Math.min(headerOffset, visibleBottomOffset);
      product.style.setProperty('--ft-pdp-adaptive-sticky-top', `${Math.round(top)}px`);
      product.dataset.ftStickyColumn = column;
    };

    const schedule = () => {
      if (queued) return;
      queued = window.requestAnimationFrame(update);
    };
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(media);
      observer.observe(info);
    }
    window.addEventListener('resize', schedule, { passive: true });
    // This listener is needed only for the 3-photo layout: the floating header
    // changes position during scroll, and our media must follow its bottom edge.
    if (threePhotoGallery) window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    /* Media and product recommendations may be hydrated after first paint. */
    page.addEventListener('recommendations:loaded', schedule);
    page.addEventListener('variant:changed', schedule);
    schedule();
  }

  function initPage(page) {
    if (!page) return;
    /* Render delivery immediately; this must never depend on optional PDP extras. */
    delivery(page);
    removeLegacySwatchKing(page);
    installPriceObserver(page);
    initializeExtras(page);
    initializeLooks(page);
    installAdaptiveColumnSticky(page);
    installWishlistButton(page);
    installPurchaseStateWatcher(page);
    syncPurchaseState(page);
  }

  function initAll() {
    document.querySelectorAll('product-info.ft-pdp').forEach(initPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();

  /* Only the countdown ticks every second; the complete PDP initializer no longer loops forever. */
  window.setInterval(() => delivery(document), 1000);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('product-info.ft-pdp').forEach(initPage);
  });


  document.addEventListener('variant:changed', (event) => {
    const page = event.target.closest?.('product-info.ft-pdp') || document.querySelector('product-info.ft-pdp');
    if (!page) return;
    syncKlarna(page);
    updateDeliveryVariant(page, event.detail?.variant);
    // Club Fashiontiger: recalculate earned points when a product variant changes.
    if (typeof event.detail?.variant?.price === 'number') {
      const points = Math.floor(event.detail.variant.price / 100);
      page.querySelectorAll('[data-ft-loyalty-earned]').forEach((el) => {
        el.textContent = String(points);
      });
    }
    const wishlist = page.querySelector('[data-ft-pdp-wishlist-button]');
    if (wishlist && event.detail?.variant?.id) {
      wishlist.dataset.ftVariantId = String(event.detail.variant.id);
      syncWishlistButton(page);
    }
    installWishlistButton(page);
    syncPurchaseState(page);
  });
})();
